const createCheckinHeatmapLayer = (id, sourceId) => {
  return {
    id,
    type: 'heatmap',
    source: sourceId,
    paint: {
      'heatmap-intensity': 0.8,
      'heatmap-opacity': 0.3
    }
  };
};

export { createCheckinHeatmapLayer };
